<template>
  <div class="card card-carousel overflow-hidden h-100 p-0">
    <div class="carousel slide h-100 position-relative">
      <div class="carousel-inner border-radius-lg h-100">
        <div v-for="(slide, idx) in slides" :key="idx" class="carousel-item h-100 bg-warning"
          :class="{ active: idx === currentSlide }">
          <div class="col-lg-12">
            <div class="row d-flex align-items-center justify-content-center text-center mt-6">
              <img :src="slide.logoRoute" alt="allo" class="img-fluid" style="max-width: 500px;">
            </div>
            <div class="row">
              <div class="carousel-caption d-none d-md-block bottom-0 text-start start-0 ms-5">
                <div class="icon icon-shape bg-white text-center border-radius-md mb-3">
                  <div v-if="slide.icon" class="d-flex align-items-center justify-content-center">
                    <div class="mt-2">
                      <img :src="slide.iconRoute" alt="ico" height="30" width="30">
                    </div>
                  </div>
                  <div v-else class="d-flex align-items-center justify-content-center">
                    <i :class="slide.iconClass"></i>
                  </div>
                </div>
                <h5 class="text-white mb-1">{{ slide.title }}</h5>
                <p v-html="slide.text"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Controles -->
      <button class="carousel-control-prev w-5 me-3" type="button" @click="prevSlide">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Anterior</span>
      </button>
      <button class="carousel-control-next w-5 me-3" type="button" @click="nextSlide">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Siguiente</span>
      </button>

    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const slides = [
  {
    icon: true,
    logoRoute: require('@/assets/img/allo-powered-white.png'),
    iconRoute: require('@/assets/img/allo-icon.svg'),
    iconClass: '',
    title: "Bienvenid@ a ALLO!",
    text: "La nueva plataforma de gestión de procesos y operaciones de <b>Nexon Automation</b>."
  },
    {
    icon: false,
    logoRoute: require('@/assets/img/allo-powered-white.png'),
    iconRoute: '',
    iconClass: 'ni ni-time-alarm text-warning opacity-10',
    title: `Antes "app de horas"`,
    text: "Lo que antes era conocido cómo la app de horas a app de Nexon,  <br> trancisiona a <b>ALLO</b> una nueva plataforma que centraliza multiples <br> procesos de la organización."
  },
  {
    icon: false,
    logoRoute: require('@/assets/img/allo-powered-white.png'),
    iconRoute: '',
    iconClass: 'ni ni-email-83 text-warning opacity-10',
    title: "¿Tienes alguna duda?",
    text: "Escribenos a <b>app.support@nexonautomation.com</b> para resolver las dudas que tengas de manera personalizada."
  }
]

const currentSlide = ref(0)
let intervalId = null

const nextSlide = () => {
  currentSlide.value = (currentSlide.value + 1) % slides.length
}

const prevSlide = () => {
  currentSlide.value = currentSlide.value === 0 ? slides.length - 1 : currentSlide.value - 1
}


onMounted(() => {
  intervalId = setInterval(nextSlide, 5000)
})

onBeforeUnmount(() => {
  if (intervalId) {
    clearInterval(intervalId)
  }
})
</script>

<style scoped>
.carousel-item {
  display: none;
}

.carousel-item.active {
  display: block;
}
</style>